import { render } from "./splashScreen.vue?vue&type=template&id=31d59c0d&scoped=true"
import script from "./splashScreen.vue?vue&type=script&lang=js"
export * from "./splashScreen.vue?vue&type=script&lang=js"

import "./splashScreen.vue?vue&type=style&index=0&id=31d59c0d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d59c0d"]])

export default __exports__